import React, { Fragment, useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useDispatch, useSelector } from 'react-redux'
import { eliminarRelacionesCliente } from '../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function ProductoresComponet(props) {
  const dispatch = useDispatch()
  let relacionProductor = props?.relacionProductor
  const usuarioCompleto = useSelector(store => store.Usuario.user)

  const Editar = (value) => {
    props?.setDataEditar(value)
    props?.setEditar(true)
    props?.setOpenModal(true)
    props?.setTipoRelacion('PRODUCTOR')
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    height: 'fit-content',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px'
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#EDB75A"
      },
      secondary: {
        main: "#DC3545"
      }
    },
    typography: {
      fontFamily: "Montserrat",
      textTransform: 'none',
      button: {
        fontSize: 16,
        fontWeight: 500,
        fontFamily: "Montserrat",
        textTransform: 'none'
      }
    }
  });

  const [openModal, setOpenModal] = React.useState(false);
  const [dataEliminar, setDataEliminar] = React.useState(false);
  const handleOpenModal = (value) => {
    setDataEliminar(value)
    setOpenModal(true)
  }
  const handleCloseModal = () => { setOpenModal(false) }

  const modalComponent = () => {
    return (
      <div>
        <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style}>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
              <label className='text-center'><b>ADVERTENCIA</b></label>
              <label className='mt-3'>¿Está seguro que desea eliminar la relación entre cliente y productor?</label>
            </Typography>
            <br />
            <ThemeProvider theme={theme}>
              <div className='row'>
                <div className='col-6 col-md-6'>
                  <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                </div>
                <div className='col-6 col-md-6'>
                  <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnEliminar() }}>Continuar</Button>
                </div>
              </div>
            </ThemeProvider>
          </Box>
        </Modal>
      </div>
    )
  }
  const btnEliminar = async () => {
    await dispatch(eliminarRelacionesCliente(dataEliminar?.idrelacionclientes))
    handleCloseModal()
    props?.setEliminar(true)
  }

  return (
    <Fragment>
      <div>
        <List sx={{ width: '110%', marginTop: '15px' }}>
          {relacionProductor?.length > 0 &&
            <ListItem key={1} disableGutters
              style={{ marginLeft: 0, marginRight: 0 }}
              secondaryAction={
                <Fragment>
                  <IconButton aria-label="comment"></IconButton>
                  <IconButton aria-label="comment"></IconButton>
                </Fragment>
              }
            >
              <ListItemText primary={`Número de socio`} style={{ width: '100px', textAlign: 'center' }} primaryTypographyProps={{ fontWeight: 'bold', fontSize: 'large' }} />
              <ListItemText primary={`Nombre o Razón social`} style={{ width: '300px', textAlign: 'center' }} primaryTypographyProps={{ fontWeight: 'bold', fontSize: 'large' }} />
              <ListItemText primary={`Marca`} style={{ width: '120px', textAlign: 'center' }} primaryTypographyProps={{ fontWeight: 'bold', fontSize: 'large' }} />
            </ListItem>
          }
          {relacionProductor.map((value, index) => (
            <ListItem key={index} disableGutters style={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)', marginTop: '2%', borderRadius: '5px' }}
              secondaryAction={
                <Fragment>
                  {(usuarioCompleto?.[0]?.tipousuario?.idtipousuario != 2 && usuarioCompleto?.[0]?.tipousuario?.idtipousuario != 1) &&
                    <Fragment>
                      <IconButton aria-label="comment" onClick={() => Editar(value)} > <EditIcon style={{ color: '#DC3545' }} /> </IconButton>
                      <IconButton aria-label="comment" onClick={() => handleOpenModal(value)}> <DeleteForeverIcon style={{ color: '#DC3545' }} /> </IconButton>
                    </Fragment>
                  }
                </Fragment>
              }
            >
              <ListItemText primary={`${value?.productor}`} style={{ width: '20%', textAlign: 'center' }} />
              <ListItemText primary={`${value?.nombrerazonsocial.toUpperCase()}`} style={{ width: '40%', textAlign: 'center' }} />
              <ListItemText primary={`${value?.marca.toUpperCase()}`} style={{ width: '30%', textAlign: 'center' }} />
            </ListItem>
          ))}
        </List>
      </div>
      {modalComponent()}
    </Fragment>
  );
}

export default ProductoresComponet;